import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching notifications and counts
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useNotificationsQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["notifications", userId],
    queryFn: async () => {
      const [notificationsRes, followRequestsRes] = await Promise.all([
        api.get("/users/me/notifications/unread-count"),
        api.get("/users/me/follow-requests"),
      ]);

      return {
        unreadNotifications: notificationsRes.data.count || 0,
        unreadMessages: notificationsRes.data.messageCount || 0,
        followRequests: followRequestsRes.data.requests || [],
      };
    },
    enabled: enabled && !!userId,
    refetchInterval: 60000, // Refetch every minute for notifications
  });
};
